var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vue-btn fav",
      class: { thinking: _vm.thinking },
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.setFav.apply(null, arguments)
        }
      }
    },
    [
      _c("i", {
        staticClass: "fa-heart",
        class: { fas: _vm.fav, far: !_vm.fav }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }